import { ArrowIcon } from "../../../assets/icons";

export const profileButtons = [
    {
        path: "/auth/updatePassword",
        text: "Сменить пароль",
        icon: <ArrowIcon />,
        type: "secondary"
    },
    {
        path: "/auth/twoFactor",
        text: "Двухфакторная аутентификация",
        icon: <ArrowIcon />,
        type: "secondary"
    },
];
